export const showNotification = (title, body, icon = '/favicon.ico') => {
    if (!('Notification' in window)) {
      return
    }
  
    if (Notification.permission === 'granted') {
      const options = {
        body: body,
        icon: icon,
        requireInteraction: false
      }
  
      const notification = new Notification(title, options)
  
      notification.onclick = () => {
        window.focus()
        notification.close()
      }
  
      setTimeout(() => {
        notification.close()
      }, 9000)
    }
  }